import { render } from "./CaseTable.vue?vue&type=template&id=3046dcba"
import script from "./CaseTable.vue?vue&type=script&lang=js"
export * from "./CaseTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__